import { builder } from './builder';
import { units } from './constants';

export const contentDiscoveryConfig = builder.holder({
  useContentDiscovery: builder.boolean('use_content_discovery', {
    defaultValue: false,
    l:'',
    d:''
  }),
  title: builder.string('content_discovery_title', {
    l:'',
    d:'',
    if: 'use_content_discovery'
  }),
  hasImage: builder.exists('content_discovery_image_1', {
    defaultValue: false
  }),
  imageUrl1: builder.string('content_discovery_image_1', {
    l:'',
    d:'',
    overrideType: 'image',
    if: 'use_content_discovery'
  }),
  text1: builder.string('content_discovery_text_1', {
    l:'',
    d:'',
    if: 'use_content_discovery'
  }),
  noBounceUrl1: builder.string('content_discovery_nobounce_1', {
    l:'',
    d:'',
    if: 'use_content_discovery'
  }),
  imageUrl2: builder.string('content_discovery_image_2', {
    if: 'use_content_discovery',
    optional: true,
    l:'',
    d:'',
    overrideType: 'image'
  }),
  text2: builder.string('content_discovery_text_2', {
    if: 'use_content_discovery',
    optional: true,
    l:'',
    d:''
  }),
  noBounceUrl2: builder.string('content_discovery_nobounce_2', {
    if: 'use_content_discovery',
    optional: true,
    l:'',
    d:''
  }),
  imageUrl3: builder.string('content_discovery_image_3', {
    if: 'use_content_discovery',
    optional: true,
    l:'',
    d:'',
    overrideType: 'image'
  }),
  text3: builder.string('content_discovery_text_3', {
    if: 'use_content_discovery',
    optional: true,
    l:'',
    d:''
  }),
  noBounceUrl3: builder.string('content_discovery_nobounce_3', {
    if: 'use_content_discovery',
    optional: true,
    l:'',
    d:''
  }),
  autoCloseDuration: builder.number('content_discovery_acd', {
    optional: true,
    // Warning if you change the default value, it is also set in a getParameter function in browser-sdk3/index.js
    defaultValue: 5,
    l:'',
    d:'',
    if: 'use_content_discovery',
    unit: units.seconds
  }),
  displayCloseButton: builder.boolean(
    'content_discovery_display_close_button',
    {
      // Warning if you change the default value, this parameter is forced to be true in browser-sdk3/index.js
      defaultValue: true,
      l:'',
      d:'',
      if: 'use_content_discovery'
    }
  ),
  useLoader: builder.boolean('content_discovery_use_loader', {
    l:'',
    defaultValue: false,
    d:''
  }),
  redirectUrl: builder.string('content_discovery_redirect_url', {
    l:'',
    defaultValue: '',
    d:''
  }),
  loaderTimeout: builder.number('content_discovery_loader_timeout', {
    l:'',
    defaultValue: 5,
    d:'',
    unit: units.seconds
  }),
  loaderCloseUrlRegex: builder.string(
    'content_discovery_loader_close_url_regex',
    {
      l:'',
      defaultValue: '',
      d:''
    }
  ),
  loaderImage: builder.string('content_discovery_loader_image', {
    l:'',
    defaultValue: '',
    d:''
  }),
  loaderColor: builder.string('content_discovery_loader_color', {
    l:'',
    defaultValue: '#ef3834',
    d:''
  }),
  triggerUrlRegex: builder.string('content_discovery_trigger_url_regex', {
    l:'',
    defaultValue: ''
  }),
  useFullscreen: builder.boolean('content_discovery_use_fullscreen', {
    l:'',
    defaultValue: false
  }),
  closeBtnSize: builder.number('content_discovery_close_btn_size', {
    l:'',
    defaultValue: 20,
    unit: units.pixel
  }),
  closeBtnColor: builder.string('content_discovery_close_btn_color', {
    l:'',
    defaultValue: '#575757'
  }),
  useCountdownCloseButton: builder.boolean(
    'content_discovery_use_countdown_close_button',
    {
      if: 'use_content_discovery',
      defaultValue: true,
      l:'',
      d:''
    }
  ),
  closeButtonDelay: builder.number('content_discovery_close_button_delay', {
    if: 'use_content_discovery',
    optional: true,
    defaultValue: 3,
    l:'',
    d:'',
    unit: units.seconds
  }),
  customTranslations: builder.object('content_discovery_translations', {
    defaultValue: {},
    d:''
  }),
  objectFit: builder.string('content_discovery_object_fit', {
    possibleValues: [
      {
        name: 'Cover',
        value: 'cover'
      },
      {
        name: 'Contain',
        value: 'contain'
      }
    ],
    defaultValue: 'contain'
  }),
  blurEffect: builder.holder({
    show: builder.boolean('content_discovery_blur_effect_show', {
      defaultValue: true,
      l:'',
      d:''
    }),

    zoom: builder.number('content_discovery_blur_effect_zoom', {
      defaultValue: 0,
      l:'',
      d:''
    }),

    offsetX: builder.number('content_discovery_blur_effect_offsetX', {
      defaultValue: 0,
      l:'',
      d:'',
      unit: units.pixel
    }),

    offsetY: builder.number('content_discovery_blur_effect_offsetY', {
      defaultValue: 0,
      l:'',
      d:'',
      unit: units.pixel
    })
  })
});
